import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  Modal,
  Box,
  TextField,
  Typography,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  InputAdornment, // Import Grid from MUI
} from "@mui/material";
import ApiEndpoints, { BASE_URL } from "../../network/ApiEndPoints";
import { get, postJsonData } from "../../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Loader from "../../component/loading-screen/Loader";
import AuthContext from "../../store/AuthContext";
import axios from "axios";
import { PATTERNS } from "../../utils/ValidationUtil";
import { Edit, Visibility, VisibilityOff } from "@mui/icons-material";
import { whiteColor } from "../../theme/setThemeColor";
import CloseIcon from "@mui/icons-material/Close";
import Spinner from "../../component/loading-screen/Spinner";
import SmallLoader from "../../component/loading-screen/SmallLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 5,
  height: "max-content",
  overflowY: "auto",
  borderRadius: "10px",
};
export const AddCustomer = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    gender: "", // Initially empty
    username: "",
    mobile: "",
    email: "",
    password: "",
    role: "",
    status: "",
    sub_role: "",
  });
  const [utilName, setUtilName] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [updatedData, setUpdatedData] = useState({});
  const [utilType, setUtilType] = useState();

  const [roles, setRoles] = useState([]);
  const [subRoles, setSubRoles] = useState([]);
  const [rolesFetched, setRolesFetched] = useState(false);
  const [subRolesFetched, setSubRolesFetched] = useState(false);
  const [imageURLs, setImageURLs] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [isPassValid, setIsPassValid] = useState(true);
  const getRoles = useCallback(
    async (queryType) => {
      let query = queryType === "role" ? "type=Role" : "type=SubRole";
      let url = `${ApiEndpoints.GET_UTILS}?${query}`;
      if (
        (queryType === "role" && rolesFetched) ||
        (queryType === "subRole" && subRolesFetched)
      ) {
        return;
      }
      setLoading(true);
      get(
        url,
        "",
        setLoading,
        (res) => {
          const rolesArray = res.data.data || [];
          if (queryType === "role") {
            setRoles(rolesArray.map((item) => item.name));
            setRolesFetched(true);
          } else {
            setSubRoles(rolesArray.map((item) => item.name));
            setSubRolesFetched(true);
          }
          setLoading(false);
        },
        (error) => {
          apiErrorToast(error);
          setLoading(false);
        }
      );
    },
    [rolesFetched, subRolesFetched]
  );

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      gender: "",
      username: "",
      mobile: "",
      email: "",
      password: "",
      role: "",
      status: "",
      establishment: "", // Reset establishment name on close
    });
  };
  const handleOpen = () => {
    setOpen(true);
    getRoles("role");
    getRoles("subRole"); 
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === "status" ? Number(value) : value, // Convert status to number
    });

    if (name === "role") {
      setSelectedRole(value);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setRequest(true);

    postJsonData(
      ApiEndpoints.CREATE_USERS_BIGG,
      formData,
      setRequest,
      (res) => {
        okSuccessToast(res.data.message);
        handleClose();
        refresh();
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setFormData({ ...formData, password: newPassword });
    setIsPassValid(PATTERNS.PASSWORD.test(newPassword));
  };
  useEffect(() => {
    getRoles();
  }, []);
  return (
    <div>
      <Button
        onClick={handleOpen}
        startIcon={
          <IconButton sx={{ p: 0, color: whiteColor() }}>
            <AddCircleOutlineIcon />
          </IconButton>
        }
        size="small"
        color="success"
        variant="contained"
        sx={{
          padding: 1,
          backgroundColor: "#2F3B57",
          borderRadius: "6px",
          color: whiteColor(),
        }}
      >
        Add User
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style} className="sm_modal">
          <SmallLoader loading={request} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
              p: 1,
              borderBottom: "2px solid #ccc",
            }}
          >
            <Typography
              sx={{ fontSize: "22px", fontWeight: "bold", color: "#000" }}
            >
              Add User
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            Box
            component="form"
            id="add-customer"
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={1.2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  Name
                </Typography>
                <TextField
                  fullWidth
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="textfield"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  Gender
                </Typography>
                <TextField
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  select
                  fullWidth
                  required
                  className="textfield"
                >
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  Username
                </Typography>
                <TextField
                  fullWidth
                  className="textfield"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  Mobile
                </Typography>

                <TextField
                  fullWidth
                  className="textfield"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Typography variant="body1" gutterBottom>
                  Email
                </Typography>
                <TextField
                  fullWidth
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="textfield"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  Password
                </Typography>
                <TextField
                  fullWidth
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handlePasswordChange}
                  className="textfield"
                  error={!isPassValid}
                  helperText={
                    !isPassValid
                      ? "Password must be alphanumeric, include one special character, and be at least 8 characters long."
                      : ""
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  Role
                </Typography>
                <TextField
                  name="role"
                  select
                  value={formData.role}
                  onChange={handleChange}
                  onClick={() => getRoles("role")}
                  required
                  fullWidth
                  className="textfield"
                   disabled={loading && !rolesFetched}
                >
                  {roles.map((role, index) => (
                    <MenuItem key={index} value={role}>
                      {role}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {formData.role === "Merchant" && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" gutterBottom>
                    Establishment Name
                  </Typography>
                  <TextField
                    fullWidth
                    name="establishment"
                    value={formData.establishment}
                    onChange={handleChange}
                    className="textfield"
                    required
                  />
                </Grid>
              )}
              {selectedRole === "Developer" && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" gutterBottom>
                    Sub Role
                  </Typography>
                  <TextField
                    name="sub_role"
                    value={formData.sub_role}
                    onChange={handleChange}
                    onClick={() => getRoles("subRole")}
                    required
                    className="textfield"
                    select
                    fullWidth
                  >
                    {subRoles.map((subRole, index) => (
                      <MenuItem key={index} value={subRole}>
                        {subRole}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  Status
                </Typography>
                <TextField
                  select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  required
                  className="textfield"
                  fullWidth
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>Inactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <ModalFooter
              form="add-customer"
              request={request}
              btn="Add User"
              autoComplete="off"
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
